import { SIGNATURE_CURATED_HERO_FALLBACK } from "@/data/signatureMediaFallbacks";

const WEAK_MEDIA_KEYWORDS = [
  "location_map",
  "location-map",
  "floorplan",
  "floor-plan",
  "floor_plan",
  "siteplan",
  "site-plan",
  "site_plan",
  "stackplan",
  "stack-plan",
  "stack_plan",
  "brochure",
  "poster",
  "teaser",
  "logo",
  "diagram",
  "chart",
  "masterplan",
  "master-plan",
  "master_plan",
  "unitmix",
  "unit-mix",
  "unit_mix",
  "elevation",
  "route_map",
  "showflat_location",
];

const WEAK_MEDIA_LABELS = [
  "location map",
  "floor plan",
  "site plan",
  "stack plan",
  "brochure",
  "promo graphic",
  "promotional graphic",
  "master plan",
  "unit mix",
  "diagram",
  "chart",
];

const decodeCloudfrontPayload = (value = "") => {
  try {
    const segment = String(value || "").split("/").filter(Boolean).at(-1) || "";
    if (!segment.startsWith("ey")) return "";
    const paddedSegment = `${segment}${"=".repeat((4 - (segment.length % 4)) % 4)}`;
    return atob(paddedSegment);
  } catch {
    return "";
  }
};

const normalizeValue = (value = "") => {
  const decodedValue = decodeURIComponent(String(value || "")).toLowerCase();
  const decodedPayload = decodeCloudfrontPayload(value).toLowerCase();
  return `${decodedValue} ${decodedPayload}`.trim();
};

export const isWeakHeroMedia = (src = "", detectedLabels = []) => {
  const normalizedSrc = normalizeValue(src);
  const hasWeakKeyword = WEAK_MEDIA_KEYWORDS.some((keyword) => normalizedSrc.includes(keyword));
  const hasWeakLabel = (detectedLabels || []).some((label) => {
    const normalizedLabel = normalizeValue(label);
    return WEAK_MEDIA_LABELS.some((weakLabel) => normalizedLabel.includes(weakLabel));
  });
  return hasWeakKeyword || hasWeakLabel;
};

export const getListingHeroPresentation = (listing, galleryImages = []) => {
  const showcase = listing?.project_showcase || {};
  const visualIntegrity = showcase.visual_integrity || {};
  const detectedLabels = visualIntegrity.detected_labels || [];
  const heroCandidates = [
    visualIntegrity.hero_image_url,
    ...(visualIntegrity.clean_images || []),
    ...galleryImages,
    listing?.image_url,
  ].filter(Boolean);
  const strongHeroImage = heroCandidates.find((candidate) => !isWeakHeroMedia(candidate, detectedLabels)) || null;
  const usingCuratedFallback = !strongHeroImage;
  const heroMode = usingCuratedFallback ? "curated-fallback" : "image";
  const heroImage = usingCuratedFallback ? SIGNATURE_CURATED_HERO_FALLBACK.src : strongHeroImage;

  return {
    heroMode,
    heroImage,
    detectedLabels,
    ruleVersion: visualIntegrity.rule_version || null,
    usingCuratedFallback,
    fallbackAlt: usingCuratedFallback ? SIGNATURE_CURATED_HERO_FALLBACK.alt : null,
  };
};